// Canonical discipline taxonomy for the CRM.
// Kept in sync with server/scripts/sync-zoho-all-contacts.js DISCIPLINE_RULES.
// Alphabetized (Tom's standing rule for items under any heading).

export const DISCIPLINES = [
  'Architect',
  'Builder',
  'Client',
  'Client Rep',
  'Competitor',
  'Designer',
  'Developer',
  'Electrical Contractor',
  'Engineer',
  'General Contractor',
  'HVAC',
  'Lead',
  'Lighting Consultant',
  'Other',
  'Prospect',
  'Real Estate',
];

// Office locations used as filters on zoho_contacts.acs_location.
export const ACS_OFFICES = ['NY', 'FL', 'CA'];
